import React, { useState } from 'react'
import Select from "react-select"
import Creatable from "react-select/creatable"
import pluralize from 'pluralize'
import { Upload, Switch, message } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'

import { useListData, usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'

import Ingredients from './ingredients'
import Variant from './variant'

const SaleItem = ({ toggle, visible, item: itm, onPerform }) => {
    let type = itm?.type === 'variant' ? itm?.ref ? 'Sale Item' : 'Prepared Item' : itm.type

    const [name, setName] = useState(itm?.name)
    const [category, setCategory] = useState({ label: itm?.category, value: itm?.category })
    const [invRef, setInvRef] = useState(itm?.ref && { label: itm?.ref.name, value: itm?.ref._id })

    const [price, setPrice] = useState(itm?.price)
    const [variants, setVariants] = useState(itm?.variants ?? [])
    const [categories, setCategories] = useState([])

    const [itemType] = useState({ label: type, value: type })
    const [ingredients, setIngredients] = useState(itm?.ingredients)
    const [imageUrl, setImageUrl] = useState(null)
    const [image, setImage] = useState(null)
    const [string, setString] = useState('')
    const [conversionRate, setConversionRate] = useState(itm?.conversionRate ?? 1)
    
    const [hasVariants, toggleHasVariants] = useToggle(itm?.variants.length > 0)
    const [imgLoading, setImgLoading] = useState(false)
    const [ingredientsModal, toggleIngredientsModal] = useToggle()
    const [variantsModal, toggleVariantsModal] = useToggle()

    const [{ loading: invLoading, fetch: fetchInvItems }, { list: items = [] }] = useListData('inventoryItems', { string }, { notify: true }, 'items')
    
    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Changes have been saved', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('editSaleItem', {
        id: itm?._id, 
        name, 
        category: category?.value, 
        price, 
        ref: invRef ? invRef._id : null,
        ingredients: ingredients?.map(itm => ({
            item: itm._id,
            quantity: itm.qty
        })),
        conversionRate
    }, { notify: true, hasFile: true, callback: onComplete, manual: true, load: { msg: 'Editing sale item...' } })

    const [{ loading: catsLoading, error: catsError }] = usePet('saleItemCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'price':
                setPrice(e.target.value)
                break

            case 'conversion-rate':
                setConversionRate(e.target.value)
                break

            default:
                break
        }
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    const beforeUpload = file => {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isImage) {
            message.warning('Please select an image file')
            return false
        }

        const sizeOK = file.size / 1024 / 1024 <= 1
        if (!sizeOK) {
            message.warning('Please select an image smaller than 1MB')
            return false
        }

        setImageUrl(null)
        setImage(file)
        setImgLoading(true)

        setTimeout(() => {
            setImageUrl(URL.createObjectURL(file))
            setImgLoading(false)
        }, 1000)

        return false
    }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setImgLoading(true)
            return
        }

        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, url => {
                setImageUrl(url)
                setImgLoading(false)
            })
        }
    }

    const removeImage = () => {
        setImage(null)
        setImageUrl(null)
    }

    const deleteIngredient = i => {
        let temp = [...ingredients]
        temp = temp.filter((_, index) => i !== index)

        setIngredients(temp)
    }

    const addVariant = vrnt => {
        let temp = [...variants]
        temp.push(vrnt)

        setVariants(temp)
    }

    const deleteVariant = i => {
        let temp = [...variants]
        temp = temp.filter((_, index) => i !== index)

        setVariants(temp)
    }

    return (
        <Modal
            h="h-auto"
            w="w-2/3 md:w-1/2 lg:w-1/2 xl:w-1/3"
            align="items-start"
            top="mt-10"
            bottom="pb-10"
            title="Edit Sale Item"
            toggle={toggle}
            visible={visible}>
            <div className="divide-y divide-light-gray-400">
                <Variant
                    setString={ setString }
                    loading={ invLoading }
                    fetch={ fetchInvItems }
                    items={ items }
                    type={ itemType }
                    onSave={ addVariant}
                    visible={variantsModal}
                    toggle={toggleVariantsModal} />
                <Ingredients
                    ingredients={ ingredients }
                    onSave={setIngredients}
                    visible={ingredientsModal}
                    toggle={toggleIngredientsModal} />
                {/* <div className="w-full flex flex-col md:flex-row"> */}
                    {/* <div className="w-full md:w-3/12 h-auto text-center m-auto lg:block lg:w-5/12">
                        <p className="text-gray-500 text-xs italic">Image of Item</p>
                        <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                            beforeUpload={beforeUpload}
                            onChange={handleChange}>
                            {
                                imageUrl ?
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        style={{ width: '100%' }} />
                                    :
                                    <div>
                                        {imgLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                        <div style={{ marginTop: 8 }}>{imgLoading ? 'Generating preview...' : 'Upload image'}</div>
                                    </div>
                            }
                        </Upload>
                        {
                            image && <p onClick={removeImage} className="text-red-500 cursor-pointer text-xs italic">X Remove</p>
                        }
                    </div> */}
                    {/* <div className="w-full lg:w-7/12 bg-white p-5"> */}
                        <div className="flex flex-wrap -mx-3 pt-5 mb-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Name
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-name"
                                    onChange={modify}
                                    value={name}
                                    type="text"
                                    name="name"
                                    placeholder="French Fries" />
                            </div>
                            {
                                itemType &&
                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                        Category
                                    </label>
                                    <Receive
                                        loading={catsLoading}
                                        error={catsError}>
                                        <Creatable
                                            value={category}
                                            onCreateOption={ val => {
                                                let temp = [...categories]
                                                temp.push(val)
                                                setCategories(temp)
                                                setCategory({ label: val, value: val })
                                            }}
                                            onChange={setCategory}
                                            options={categories.map(cat => ({ label: cat, value: cat }))}
                                            placeholder="Select Category" />
                                    </Receive>
                                </div>
                            }
                        </div>
                        {
                            itemType &&
                            <>
                                {
                                    hasVariants &&
                                    <div className="font-bold mt-3">
                                        <div className="flex justify-between items-center">
                                            <p className="font-bold my-3">Variants</p>
                                            <button onClick={toggleVariantsModal} className="btn hisani-btn-green text-white my-3">
                                                <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                                <span className="hidden xs:block ml-2">Add</span>
                                            </button>
                                        </div>
                                        {
                                            variants.length > 0 ?
                                                <table className="table-auto w-full mb-3">
                                                    {/* Table header */}
                                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                        <tr>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">No</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Variant</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Price</div>
                                                            </th>
                                                            <th />
                                                        </tr>
                                                    </thead>
                                                    {/* Table body */}
                                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                        {
                                                            variants.map((variant, key) =>
                                                                <tr>
                                                                    <td className="p-2 text-left">{key + 1}</td>
                                                                    <td className="p-2 text-left">{variant.name}</td>
                                                                    <td className="p-2 text-left">Ksh. {variant.price}</td>
                                                                    <td onClick={() => deleteVariant(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                                :
                                                <div className="text-center my-4">
                                                    <h3>Please click above to add variants</h3>
                                                </div>
                                        }
                                    </div>
                                }
                                <div className="flex flex-wrap -mx-3 pt-4 mb-3">
                                    {
                                        !hasVariants &&
                                        <>
                                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                                    Price
                                                </label>
                                                <input
                                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    id="grid-price"
                                                    value={price}
                                                    onChange={modify}
                                                    name="price"
                                                    type="number"
                                                    placeholder="XXXX" />
                                            </div>
                                            {
                                                itemType?.value === 'Sale Item' &&
                                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                                        Conversion Rate
                                                    </label>
                                                    <input
                                                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                        id="grid-conversion-rate"
                                                        type="text"
                                                        name="conversion-rate"
                                                        value={conversionRate}
                                                        onChange={modify}
                                                        placeholder="1/2" />
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                                {
                                    !hasVariants ?
                                        itemType?.value === 'Prepared Item' ?
                                            <div className="font-bold mt-3">
                                                <div className="flex justify-between items-center">
                                                    <p className="font-bold my-3">Ingredients</p>
                                                    <button onClick={toggleIngredientsModal} className="btn hisani-btn-green text-white my-3">
                                                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                        </svg>
                                                        <span className="hidden xs:block ml-2">Add</span>
                                                    </button>
                                                </div>
                                                {
                                                    ingredients.length > 0 ?
                                                        <table className="table-auto w-full mb-3">
                                                            {/* Table header */}
                                                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                                <tr>
                                                                    <th className="p-2">
                                                                        <div className="font-semibold text-left">No</div>
                                                                    </th>
                                                                    <th className="p-2">
                                                                        <div className="font-semibold text-left">Selected</div>
                                                                    </th>
                                                                    <th className="p-2">
                                                                        <div className="font-semibold text-left">Quantity</div>
                                                                    </th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            {/* Table body */}
                                                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                                {
                                                                    ingredients.map((ingredient, key) =>
                                                                        <tr>
                                                                            <td className="p-2 text-left">{key + 1}</td>
                                                                            <td className="p-2 text-left">{ingredient?.item?.name}</td>
                                                                            <td className="p-2 text-left">{ingredient.quantity} {pluralize(ingredient?.item?.issuedIn ?? '', ingredient.quantity)}</td>
                                                                            <td onClick={ () => deleteIngredient(key) } className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                        :
                                                        <div className="text-center my-4">
                                                            <h3>Please click above to add ingredients</h3>
                                                        </div>
                                                }
                                            </div>
                                            : itemType?.value === 'Sale Item' ?
                                                <div className="flex flex-wrap -mx-3 pt-4 mb-6 bt-1 border-gray-200">
                                                    <div className="w-full md:w-2/3 px-3 mb-6 md:mb-0">
                                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                                            Inventory Item
                                                        </label>
                                                        <Select
                                                            isLoading={invLoading}
                                                            loadingMessage={string => `Searching for "${string?.inputValue}"`}
                                                            onInputChange={search}
                                                            value={invRef}
                                                            onChange={setInvRef}
                                                            options={items.map(item => ({ label: item.name, value: item._id, ...item }))}
                                                            placeholder="Search for inventory item" />
                                                        <p className="text-gray-500 text-xs italic">Which inventory item does it refer to?</p>
                                                    </div>
                                                </div>
                                                : null
                                        : null
                                }
                            </>
                        }
                    {/* </div>
                </div> */}

            </div>
            <div className="flex justify-end mt-2">
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default SaleItem